import { render, staticRenderFns } from "./ModalAgregarMarca.vue?vue&type=template&id=c2fc8a5c"
import script from "./ModalAgregarMarca.vue?vue&type=script&lang=js"
export * from "./ModalAgregarMarca.vue?vue&type=script&lang=js"
import style0 from "./ModalAgregarMarca.vue?vue&type=style&index=0&id=c2fc8a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports